<template>
  <v-card id="pdfvuer" elevation="22" :class="pageLoaded ? 'pdf-loaded' : ''">
    <v-col cols="12" xl="12" lg="12" class="pdf-main-view" :style="pageProps">
      <div v-if="pdfdata">
        <template v-for="i in numPages">
          <template
            v-if="loaded.indexOf(i) >= 0 || (i >= currentPage - Number(offscreenPages) && i <= currentPage + Number(offscreenPages))"
          >
            <pdfvuer
              class="page"
              :style="pageStyle"
              :src="pdfdata"
              :page="i"
              :key="i"
              :id="i"
              :ref="'ref' + i"
              :scale.sync="scale"
            ></pdfvuer>
          </template>
          <template v-else>
            <div class="page" :style="pageStyle" :key="i" :id="i" :ref="'ref' + i"></div>
          </template>
        </template>

        <div class="loader-bg">
          <v-skeleton-loader
            class="mx-auto"
            type="article"
            transition="fade-transition"
            v-for="i in 5"
            :key="i"
          ></v-skeleton-loader>
        </div>
      </div>

      <v-toolbar dense dark tag="div" class="pdf-toolbar">
        <v-container d-flex align-center justify-space-between :class="breakpoint">
          <v-btn-toggle
            class="page-controls"
            color="grey"
            active-class="toolbar-btn--active"
            dense
            group
          >
            <v-btn text @click="page !== 1 ? page=1 : 1">
              <v-icon>mdi-home-outline</v-icon>
            </v-btn>
            <v-btn text @click="page > 1 ? page-- : 1">
              <v-icon>mdi-skip-backward</v-icon>
            </v-btn>
            <v-btn text disabled>{{currentPage}} of {{ numPages ? numPages : '∞' }}</v-btn>
            <v-btn text @click="page < numPages ? page++ : 1">
              <v-icon>mdi-skip-forward</v-icon>
            </v-btn>
          </v-btn-toggle>

          <v-btn-toggle
            class="zoom-controls"
            color="grey darken-4"
            active-class="toolbar-btn--active"
            dense
            group
          >
            <v-btn text @click="scale -= scale > 0.25 ? 0.1 : 0">
              <v-icon>mdi-magnify-minus-outline</v-icon>
            </v-btn>
            <v-btn text disabled>{{ formattedZoom }} %</v-btn>
            <v-btn text @click="scale += scale < 2.5 ? 0.1 : 0">
              <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-btn>
          </v-btn-toggle>

          <v-spacer style="max-width: 13.5rem !important;"></v-spacer>
        </v-container>
      </v-toolbar>
    </v-col>
  </v-card>
</template>
 
<script>
import pdfvuer from "pdfvuer";
import $ from "jquery";

export default {
  components: {
    pdfvuer,
  },
  props: {
    options: Object,
    offscreenPages: String,
  },
  data: function () {
    return {
      pdfdata: undefined,
      loaded: [],
      currentPage: 1,
      numPages: 0,
      pageHeight: 0,
      page: 1,
      scale: "page-width",
      pageLoaded: false,
    };
  },
  computed: {
    pageStyle: function () {
      if (this.pageHeight == 0) return "";
      return "height: " + this.pageHeight + "px";
    },
    breakpoint: function () {
      return `screen-${this.$vuetify.breakpoint.name}`;
    },
    formattedZoom: function () {
      return Number.parseInt(this.scale * 100);
    },
    pageProps: function () {
      if (this.pageHeight !== 0 && this.currentPage < this.numPages) {
        let h1 = $(".page#" + this.page).height();
        let h2 = $(".page#" + this.page + " > #viewerContainer").height();
        return {
          "--page-margin": `${h2 - h1 + 15}px`,
        };
      } else {
        return {
          "--page-margin": `${this.scale * 1}%`,
        };
      }
    },
  },
  watch: {
    page: function (p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },
    scale: function () {
      this.removePageWidth();
      //this.changePage();
    },
  },
  methods: {
    findPos(obj) {
      return obj.offsetTop;
    },
    switchPage(p) {
      this.page = p;
    },
    removePageWidth() {
      this.pageLoaded = true;
    },
  },
  mounted: function () {
    this.pdfdata = pdfvuer.createLoadingTask(this.options);
    this.pdfdata.then((pdf) => {
      let self = this;
      this.numPages = pdf.numPages;

      for (
        let i = this.currentPage;
        i <= this.currentPage + Number(this.offscreenPages);
        i++
      )
        this.loaded.push(i);

      self.$emit("pageChanged", {
        currentPage: 1,
        numPages: this.numPages,
      });

      window.addEventListener(
        "scroll",
        function () {
          changePage();
        },
        true
      );

      function changePage() {
        let yOffset = window.pageYOffset;
        // let yOffset = document.getElementsByClassName("content-container")[0].scrollTop;
        let previousPage = self.currentPage;
        let i = 1;

        do {
          if (
            yOffset >= document.getElementById(i).offsetTop &&
            yOffset <= document.getElementById(i + 1).offsetTop
          ) {
            self.currentPage = i;
          }
        } while (++i < self.numPages);

        if (yOffset >= document.getElementById(i).offsetTop)
          self.currentPage = i;
        //self.page = self.currentPage

        if (self.currentPage != previousPage)
          self.$emit("pageChanged", {
            currentPage: self.currentPage,
            numPages: self.numPages,
          });

        for (
          let j = self.currentPage - Number(self.offscreenPages);
          j <= self.currentPage + Number(self.offscreenPages);
          j++
        ) {
          if (self.loaded.indexOf(j) < 0) self.loaded.push(j);
        }

        if (self.pageHeight == 0)
          self.pageHeight = document.getElementById(
            self.currentPage
          ).offsetHeight;
      }
    });
    // setTimeout(() => {
    //   this.removePageWidth();
    // }, 3000);
  },
  beforeDestroy: function () {
    if (this.pdfdata) this.pdfdata.destroy();
    this.pdfdata = null;
  },
};
</script>

<style>
.page {
  margin-bottom: var(--page-margin);
}
</style>

<style lang="scss" scoped>
#pdfvuer {
  width: 100%;
  height: 100%;
  transition: all 0.3s ease-in-out;
  min-width: 70rem;
  min-height: 100vh;
  padding-top: 1rem;
  padding-bottom: 1rem;

  @media screen and (max-width: 1264px) {
    min-width: calc(100vw - 5rem);
  }
  @media screen and (max-width: 960px) {
    min-width: calc(100vw - 5rem);
    margin-left: -0.4rem;
    max-width: 100vw;
    overflow: scroll;
  }
  @media screen and (max-width: 600px) {
    min-width: 100vw;
    margin-left: -0.75rem;
    margin-top: 3rem;
    max-width: 100vw;
    overflow: scroll;
    width: 100vw;
  }

  &.pdf-loaded {
    min-height: unset;
    min-width: unset;

    .loader-bg {
      display: none;
    }
  }

  .page {
    height: 100% !important;
  }
}

.loader-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  padding: 3rem;
  //z-index: -1;
  height: 100vh;
  overflow: hidden;
  margin: auto;

  @media screen and (max-width: 600px) {
    padding: 1.25rem;
  }
}

.pdf-toolbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: transparent !important;

  &::v-deep .v-toolbar__content {
    @media screen and (max-width: 600px) {
      padding: 0;
      width: 100vw;
      background: #424242;
      bottom: 2rem;
    }
  }

  .page-controls {
    margin-left: -1rem;
    @media screen and (max-width: 600px) {
      margin-left: -1.25rem;
    }
  }

  .v-btn--disabled {
    &::v-deep .v-btn__content {
      color: #fff;
    }
  }

  .toolbar-btn--active,
  .toolbar-btn--active:hover {
    &::before {
      opacity: 0;
    }

    .v-icon {
      color: #fff;
    }
  }
}
</style>